import React, { useState, useEffect } from 'react';
import { FiSmartphone, FiX, FiDownload, FiExternalLink } from 'react-icons/fi';
import './AppInstallBanner.css';

const PLAY_STORE_URL = 'https://play.google.com/store/apps/details?id=com.shubhamcomputers.shubink';
const QR_API_URL = 'https://api.qrserver.com/v1/create-qr-code/?size=160x160&data=https%3A%2F%2Fplay.google.com%2Fstore%2Fapps%2Fdetails%3Fid%3Dcom.shubhamcomputers.shubink&margin=6';
const STORAGE_KEY = 'shubink_app_install_dismissed_at';
const DISMISS_DURATION_MS = 5 * 24 * 60 * 60 * 1000; // 5 days

export default function AppInstallBanner() {
  const [isVisible, setIsVisible] = useState(false);
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    // Check if dismissed recently
    try {
      const dismissedAt = localStorage.getItem(STORAGE_KEY);
      if (dismissedAt) {
        const elapsed = Date.now() - parseInt(dismissedAt, 10);
        if (elapsed < DISMISS_DURATION_MS) {
          return;
        }
      }
    } catch (e) {
      // LocalStorage unavailable
    }

    // Delay 1.5s so initial page loads smoothly first
    const timer = setTimeout(() => {
      setIsVisible(true);
    }, 1500);

    const handleResize = () => {
      setIsMobile(window.innerWidth <= 640);
    };
    handleResize();
    window.addEventListener('resize', handleResize);

    return () => {
      clearTimeout(timer);
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  const handleDismiss = () => {
    setIsVisible(false);
    try {
      localStorage.setItem(STORAGE_KEY, String(Date.now()));
    } catch (e) {}
  };

  if (!isVisible) return null;

  return (
    <aside className="app-install-banner" aria-label="Shubink Android App Download">
      <button 
        type="button" 
        className="app-banner-close" 
        onClick={handleDismiss}
        aria-label="Dismiss app download prompt"
      >
        <FiX />
      </button>

      <div className="app-banner-header">
        <div className="app-banner-icon">
          <FiSmartphone />
        </div>
        <div>
          <h4 className="app-banner-title">Get the Shubink App</h4>
          <p className="app-banner-subtitle">
            {isMobile ? 'Faster ordering and live order tracking.' : 'Scan QR or install from Google Play Store.'}
          </p>
        </div>
      </div>

      <div className="app-banner-content">
        {!isMobile && (
          <div className="app-banner-qr-wrap">
            <img 
              src={QR_API_URL} 
              alt="Scan QR code to install Shubink Android app" 
              className="app-banner-qr" 
              width="110" 
              height="110"
              loading="lazy"
            />
            <span className="app-banner-qr-label">Scan with camera</span>
          </div>
        )}

        <div className="app-banner-details">
          <ul className="app-banner-features">
            <li>Instant order updates and tracking</li>
            <li>Under 30-min express printing</li>
            <li>Quick re-orders and wallet payments</li>
          </ul>

          <a 
            href={PLAY_STORE_URL} 
            target="_blank" 
            rel="noopener noreferrer" 
            className="app-banner-btn"
          >
            <FiDownload />
            <span>Open in Play Store</span>
            <FiExternalLink className="app-banner-btn-ext" />
          </a>
        </div>
      </div>
    </aside>
  );
}
